var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentRouteName !== 'Login' && _vm.currentRouteName !== 'Register')?_c('div',[_c('core-default-toolbar')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }